<script setup lang="ts">
    import { reactive, ref, computed } from 'vue'

    interface IPropsModal {
        minWidth?: string
        minHeight?: string
        width?: string
        height?: string
        maxWidth?: string
        maxHeight?: string
        visible: boolean
    }

    const props = withDefaults(defineProps<IPropsModal>(), {
        maxWidth: '75%',
        maxHeight: '75%',
    })

    const draggableContainer = ref<HTMLElement | null>()

    const positions = reactive({
        clientX: 0,
        clientY: 0,
        movementX: 0,
        movementY: 0,
    })

    const stylePopup = computed(() => {
        return {
            width: props.width,
            height: props.height,
            'min-width': props.minWidth,
            'min-height': props.minHeight,
            'max-width': props.maxWidth,
            'max-height': props.maxHeight,
        }
    })

    function dragMouseDown(event: MouseEvent) {
        event.preventDefault()
        // get the mouse cursor position at startup:
        positions.clientX = event.clientX
        positions.clientY = event.clientY
        document.onmousemove = elementDrag
        document.onmouseup = closeDragElement
    }

    function elementDrag(event: MouseEvent) {
        event.preventDefault()
        positions.movementX = positions.clientX - event.clientX
        positions.movementY = positions.clientY - event.clientY
        positions.clientX = event.clientX
        positions.clientY = event.clientY

        // set the element's new position:
        draggableContainer.value!.style.top = draggableContainer.value!.offsetTop - positions.movementY + 'px'
        draggableContainer.value!.style.left = draggableContainer.value!.offsetLeft - positions.movementX + 'px'
    }

    function closeDragElement() {
        document.onmouseup = null
        document.onmousemove = null
    }
</script>

<template>
    <transition name="cogi-modal-fade">
        <div v-show="visible" class="cogi-modal-backdrop">
            <div ref="draggableContainer" class="cogi-modal" :style="stylePopup" @mousedown="dragMouseDown">
                <slot></slot>
            </div>
        </div>
    </transition>
</template>

<style scoped>
    .cogi-modal {
        background-color: white;
        position: absolute;

        border: 2px solid blue;
        box-shadow: 2px 2px 20px 1px;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .cogi-modal-backdrop {
        background-color: rgba(123, 123, 123, 0.4);
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 100;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .cogi-modal-fade-enter,
    .cogi-modal-fade-leave-to {
        opacity: 0;
    }

    .cogi-modal-fade-enter-active,
    .cogi-modal-fade-leave-active {
        transition: opacity 0.3s ease;
    }
</style>
